import React, { useMemo } from "react";

const LegalEntityIcon = ({ width = 28, height = 23 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18.145 16.501"
      >
        <path
          id="building-07-svgrepo-com"
          d="M6.522,9.578H4.138a2.043,2.043,0,0,0-.867.09.822.822,0,0,0-.359.359,2.043,2.043,0,0,0-.09.867V17.8m11.1-8.223h2.385a2.043,2.043,0,0,1,.867.09.822.822,0,0,1,.359.359,2.043,2.043,0,0,1,.09.867V17.8m-3.7,0V5.631A4.085,4.085,0,0,0,13.743,3.9a1.644,1.644,0,0,0-.719-.719A4.086,4.086,0,0,0,11.292,3H9.154a4.085,4.085,0,0,0-1.733.179A1.644,1.644,0,0,0,6.7,3.9a4.086,4.086,0,0,0-.179,1.733V17.8m11.923,0H2M9.4,6.289h1.645M9.4,9.578h1.645M9.4,12.867h1.645"
          transform="translate(-1.15 -2.15)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
        />
      </svg>
    );
  }, []);

  return svgContent;
};

export default LegalEntityIcon;



// WEBPACK FOOTER //
// ./src/assets/LegalEntityIcon.jsx